export const softwareNotFound = 'Software not found.';
export const usersNotFound = 'Users not found.';
export const anErrorOccurred = 'An error occurred.';
export const licenseKeyNotFound = 'License key not found.';